import { render, staticRenderFns } from "./hq-title.vue?vue&type=template&id=68befaa4&scoped=true&"
import script from "./hq-title.vue?vue&type=script&lang=js&"
export * from "./hq-title.vue?vue&type=script&lang=js&"
import style0 from "./hq-title.vue?vue&type=style&index=0&id=68befaa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68befaa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68befaa4')) {
      api.createRecord('68befaa4', component.options)
    } else {
      api.reload('68befaa4', component.options)
    }
    module.hot.accept("./hq-title.vue?vue&type=template&id=68befaa4&scoped=true&", function () {
      api.rerender('68befaa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/hq-title.vue"
export default component.exports